import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import {
  FlexCenterWrapper, CursorPointerWrapper, FitRelativeWrapper,
  Mr2, Ml2, AbsolutePositionWrapper, CustomBackgroundWrapper
} from 'wrappers';
import { Icon, PrimaryTextBase, WhiteTextXs } from 'atoms';

export const definition = {
  name: 'ResidentOrderLink',
  controller: Controller,
  initialProps: ({ linkText, iconLeft, iconRight, propertyId, unitId }) => ({ linkText, iconLeft, iconRight, propertyId, unitId }),
  props: internalState,
  elements: [
    {
      wrapper: wrap(wrap(FlexCenterWrapper, CursorPointerWrapper), FitRelativeWrapper),
      name: 'WOCreation',
      isButton: true,
      bindings: ({ unitId, propertyId }) => ({ unitId, propertyId }),
      elements: [
        {
          component: wrap(Icon, Mr2),
          name: 'Icon',
          renderIf: ({ iconLeft }) => !!iconLeft,
          displayValue: ({ iconLeft }) => iconLeft
        },
        {
          component: PrimaryTextBase,
          name: 'Text',
          displayValue: ({ linkText }) => linkText,
        },
        {
          component: wrap(Icon, Ml2),
          name: 'Icon',
          renderIf: ({ iconRight }) => !!iconRight,
          displayValue: ({ iconRight }) => iconRight
        },
        {
          wrapper: AbsolutePositionWrapper,
          name: "LinkCopied",
          displayState: ({ }) => ({ left: '50%', zIndex: 100 }),
          renderIf: ({ linkCopied }) => linkCopied,
          elements: [
            {
              wrapper: CustomBackgroundWrapper,
              name: 'LinkCopied',
              displayState: ({ }) => ({ padding: '12px', background: window?.settings?.secondary_color ?? '#04333b', borderRadius: '5px' }),
              elements: [
                {
                  component: WhiteTextXs,
                  name: 'Text',
                  displayValue: ({ }) => 'Link copied'
                }
              ],
            },
          ]
        }
      ]
    },
  ]
};

export default ContainerComponent(definition);